module.exports = __webpack_public_path__ + "23886224abd66c066890c5a7d54c85d9.png";